import axios from 'core/network/interceptor';
import { CloseAgencyUrl, GetAgenciesUrl, GetAgencyUrl, PostAgencyUrl, PutAgencyUrl, ReopenAgencyUrl } from './constants';

interface createAgencyEntryVariables {
    data: any;
}

const CreateAgencyRequest = async ({data}: createAgencyEntryVariables) => {
    const response = await axios.post(PostAgencyUrl, data);

    return response.data.agency;
};

const GetAgencyRequest = async (agencyId: number) => {
    const response = await axios.get(GetAgencyUrl(agencyId));

    return response.data.agency;
};

const GetAgenciesRequest = async () => {
    const response = await axios.get(GetAgenciesUrl);

    return response.data.agencies;
};

interface updateAgencyEntryVariables {
    id: number;
    data: any;
}

const UpdateAgencyRequest = async ({id, data}: updateAgencyEntryVariables) => {
    const response = await axios.put(PutAgencyUrl(id), data);

    return response.data.agency;
};

interface closeAgencyEntryVariables {
    id: number;
    closing_message: string;
}

const CloseAgencyRequest = async ({id, closing_message}: closeAgencyEntryVariables) => {
    const response = await axios.post(CloseAgencyUrl(id), {closing_message});

    return response.data.agency;
};

const ReopenAgencyRequest = async ({id}: {id: number}) => {
    const response = await axios.post(ReopenAgencyUrl(id));

    return response.data.agency;
};

export { CreateAgencyRequest, GetAgencyRequest, GetAgenciesRequest, UpdateAgencyRequest, CloseAgencyRequest, ReopenAgencyRequest };
